import { SiteFooter } from '@/components/site-footer'
import { SiteHeader } from '@/components/site-header'
import { WebProgrammer } from '@/components/web-programmer'

export default function ProgrammerPage() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main>
        <WebProgrammer />
      </main>
      <SiteFooter />
    </div>
  )
}
